import Layout from '@/layout';

export default [
  {
    path: '/system',
    component: Layout,
    redirect: '/system/user',
    name: 'system',
    meta: {
      icon: 'Setting',
      title: '系统管理',
    },
    children: [
      {
        path: 'user',
        component: () => import('@/views/system/user/UserList.vue'),
        name: 'system-user',
        meta: {
          icon: 'UserFilled',
          title: '用户管理',
          requiresPermission: true,
        },
      },
      {
        path: 'role',
        component: () => import('@/views/system/role/RoleList.vue'),
        name: 'system-role',
        meta: {
          icon: 'Avatar',
          title: '角色管理',
          requiresPermission: true,
        },
      },
      {
        path: 'permission',
        component: () => import('@/views/system/permission/PermissionList.vue'),
        name: 'system-permission',
        meta: {
          icon: 'Menu',
          title: '权限管理',
          requiresPermission: true,
        },
      },
      {
        path: 'dict-type',
        component: () => import('@/views/system/dict/DictType.vue'),
        name: 'system-dict-type',
        meta: {
          icon: 'Notebook',
          title: '字典类型',
          requiresPermission: true,
        },
      },
      {
        path: 'dict-value',
        component: () => import('@/views/system/dict/DictValue.vue'),
        name: 'system-dict-value',
        meta: {
          icon: 'Memo',
          title: '字典值',
          requiresPermission: true,
        },
      },
      {
        path: 'log-operation',
        component: () => import('@/views/system/log/OperationLog.vue'),
        name: 'system-log-operation',
        meta: {
          icon: 'LogOperation',
          title: '操作日志',
          requiresPermission: true,
        },
      },
      {
        path: 'log-login',
        component: () => import('@/views/system/log/LoginLog.vue'),
        name: 'system-log-login',
        meta: {
          icon: 'LogLogin',
          title: '登录日志',
          requiresPermission: true,
        },
      },
      {
        path: 'log-error',
        component: () => import('@/views/system/log/ErrorLog.vue'),
        name: 'system-log-error',
        meta: {
          icon: 'WarningFilled',
          title: '错误日志',
          requiresPermission: true,
        },
      },
    ],
  },
];
